export const getTokenParams = (token: string) => {
  try {
    const tokenSegments = token.split(".");
    return JSON.parse(atob(tokenSegments[1]));
  } catch (e) {
    return {};
  }
};

export const tokenIsExpired = (token: string): boolean => {
  const compareTime = Math.floor(new Date().getTime() / 1000);
  return compareTime > getTokenParams(token).exp;
};

export const tokenIsValidForVenue = (token: string, venueId: string): boolean => {
  const tokenParams = getTokenParams(token);
  if (tokenParams.v1?.claims?.venueId) {
    return tokenParams.v1.claims.venueId === venueId;
  }
  return false;
};

export const tokenAboutToExpire = (token: string): boolean => {
  const EXPIRATION_IN_SECONDS = 900;
  const jwtExpirationSec = getTokenParams(token).exp;
  const currentSec = Math.floor(new Date().getTime() / 1000);
  return jwtExpirationSec < currentSec + EXPIRATION_IN_SECONDS;
};
